import { Component } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-cron-popap',
  templateUrl: './cron-popap.component.html',
  styleUrl: './cron-popap.component.scss',
  standalone: false
})
export class CronPopapComponent {
  processing = false;
  constructor(
    public userService: UserService,
    private dialogRef: MatDialogRef<CronPopapComponent>
  ) { }

  ngOnInit(): void { }



  setToCronJob() {
    this.processing = true;
    this.userService.setCronJob().subscribe(
      (response: any) => {
        setTimeout(() => {
          this.processing = false;
          this.dialogRef.close();
        }, 1000);
        this.userService.billingCustomer("").subscribe((response: any) => { })
      },
      (error: any) => {
        console.error('Error setting cron job:', error);
      }
    );

  }

  close() {
    this.dialogRef.close();
  }

}


